<script>
/**
 * Descripción: Componente Menú Top
 *
 * @displayName TheToolbar
 */

export default {
  name: 'TheToolbar',

  data() {
    return {
      key: null
    };
  },

  methods: {
    golinkedin() {
      window.open(
        'https://www.linkedin.com/in/pablo-madrigal-ram%C3%ADrez-7029b7147/',
        '_blank'
      );
    },

    goGithub() {
      window.open('https://github.com/pmadrigal95', '_blank');
    },

    goButtercms() {
      window.open('https://buttercms.com/', '_blank');
    }
  }
};
</script>

<template>
  <div>
    <v-navigation-drawer v-model="key" app clipped>
      <template v-slot:prepend>
        <v-img
          :src="require('@/assets/logos/logoWhite.svg')"
          loading="lazy"
          v-if="$vuetify.theme.dark"
        />

        <v-img
          :src="require('@/assets/logos/logoBlack.svg')"
          loading="lazy"
          v-else
        />
      </template>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-item link to="/">
          <v-list-item-action>
            <v-icon>mdi-home-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/Blog">
          <v-list-item-action>
            <v-icon>mdi-fire</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Posts</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/About">
          <v-list-item-action>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Acerca de</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- @ Use Logo Portal -->
      <template v-slot:append>
        <div
          class="pa-2 pointer"
          style=" display: flex;
          align-items: center;
          justify-content: center;"
          @click="goButtercms()"
        >
          <img
            src="@/assets/logos/butter-w.png"
            height="35px"
            width="120px"
            v-if="$vuetify.theme.dark"
          />
          <img
            src="@/assets/logos/butter-b.png"
            height="35px"
            width="120px"
            v-else
          />
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar>
      <v-app-bar-nav-icon @click="key = !key" />
      <v-spacer></v-spacer>

      <v-btn icon @click="goGithub()">
        <v-icon>mdi-github</v-icon>
      </v-btn>

      <v-btn icon @click="golinkedin()">
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>

      <v-switch
        v-model="$vuetify.theme.dark"
        hide-details
        inset
        color="#ffff"
      ></v-switch>
    </v-app-bar>
  </div>
</template>

<style>
.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background-color: transparent !important;
}

.theme--dark.v-navigation-drawer {
  background-color: #121212 !important;
}

.pointer {
  cursor: pointer;
}
</style>
